<template>
  <div>
    <div>
      <div class="productFeature__main" v-if="!loading">
        <div
          class="productFeature__menuMain"
          v-if="showMenuMain"
          @click="handleMenuMain()"
        >
          <div class="productFeature__menuAll">
            <h3>{{ this.slug }}</h3>
            <!-- <h3 v-if="this.subMenuHeader">/ {{this.subMenuHeader}} </h3>
          <h3>/VEG</h3> -->
          </div>
          <div>
            <font-awesome-icon color="white" icon="caret-down" />
          </div>
        </div>

        <div class="productFeature__body" v-if="showBody">
          <div class="productFeature__head">
            <h3>
              {{ this.slug }}
            </h3>
            <a-tooltip title="close">
              <img
                :src="require('../../../assets/svg/crossBlack.svg')"
                alt="close"
                @click="handleBody()"
              />
            </a-tooltip>
          </div>

          <!-- :class="
            submenu.id == SubmenuId ? 'span_Activesubmenu' : 'span__submenu'
          " -->

          <div class="productFeature__submenu">
            <div class="productFeature__submenuActive">
              All
            </div>
            <div
              :class="
                subMenuId == submenu.id
                  ? 'productFeature__submenuActive'
                  : 'productFeature__submenuInactive'
              "
              v-for="submenu in subMenuList"
              :key="submenu.id"
              @click="getSubmenuId(submenu)"
            >
              {{ submenu.name }}
            </div>
          </div>

          <div class="productFeature__subCategory">
            <div class="productFeature__submenuActive">
              All
            </div>

            <div v-if="categoryListLoading" class="productFeature__catLoading">
              Loading...
            </div>

            <div v-if="showError" class="productFeature__showError">
              <span v-if="!categoryListLoading">No Data Found</span>
            </div>

            <div
              v-else
              :class="
                categoryId == category.id
                  ? 'productFeature__submenuActive'
                  : 'productFeature__submenuInactive'
              "
              v-for="category in categoryList"
              :key="category.id"
              @click="getCategoryId(category.id)"
            >
              {{ category.name }}
            </div>
          </div>
        </div>

        <div></div>
      </div>

      <div class="main__list" v-if="showCatList">
        <!-- <div v-show="showError" class="productFeature__showError">
        No Data Foundddd.
      </div> -->

        <div class="menu-list">
          <a-list
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 4, xxl: 4 }"
            :loading="loading"
            :dataSource="catList"
            :pagination="pagination"
            :key="1"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              class="list-complete-item"
              :loading="loading"
            >
              <HomePageProductNew
                :item="item"
                :key="key"
                v-on:view-product="viewProduct($event)"
              />
            </a-list-item>
          </a-list>
        </div>
      </div>

      <div class="main__list" v-else>
        <!-- <div v-if="showNoData" class="productFeature__showError">
        No Data Found. You can use this instead  of that.
      </div> -->

        <div class="menu-list">
          <a-list
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 4, xxl: 4 }"
            :loading="loading"
            :dataSource="list"
            :pagination="pagination"
            :key="1"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              class="list-complete-item"
              :loading="loading"
            >
              <HomePageProductNew
                :item="item"
                :key="key"
                v-on:view-product="viewProduct($event)"
              />
            </a-list-item>
          </a-list>
        </div>
      </div>
    </div>
    <div v-if="popUpOn">
      <ProductPopup
        :item="popupProduct"
        v-on:close-popup="closePopup($event)"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import HomePageProductNew from "./HomePageProductNew.vue";
import { LocationId } from "../../../services/storage.service";
import ProductPopup from "../../../views/Home/ProductFeature/ProductPopup.vue";

import { mapGetters } from "vuex";

export default {
  name: "ProductFeatureList",
  components: {
    HomePageProductNew,
    ProductPopup,
  },
  data() {
    return {
      popUpOn: 0,
      // showFilterCat: 1,
      showMenuMain: false,
      showBody: true,

      showNoData: false,

      list: [],
      subMenuList: [],
      subMenuId: null,
      subMenuHeader: "",
      categoryList: [],
      categoryId: null,
      loading: true,
      showError: false,
      slug: null,
      realMenuId: null,
      showSubCategory: false,

      showCatList: false,
      catList: null,

      pagination: {
        onChange: (page) => {
          // alert(page);
          window.scrollTo(0, 0);
        },
        pageSize: 20,
      },
      categoryListLoading: true,
    };
  },

  created() {
    // this.categoryList = null;
    // this.getItemsList();

    this.slug = this.$route.params.slug;
    this.realMenuId = this.$route.params.id;
    // alert(this.realMenuId)
    this.categoryId = this.$route.params.catid;
    this.subMenuId = this.$route.params.subId;
    // alert(this.categoryId)
    // if (this.categoryId !== undefined) {
    //   this.getItemsList();
    // }
  },

  // computed: {
  //   ...mapGetters(["realMenuId"]),
  // },

  watch: {
    $route(to, from) {
      // console.log(to, "helllooooooooo");
      // alert("helllo")
      // this.getSubMenuList();
      this.slug = to.params.slug;
      this.realMenuId = to.params.id;
      this.categoryId = to.params.catid;
      this.subMenuId = to.params.subId;

      this.getMenuItemList();

      // this.categoryList = [];
    },

    realMenuId() {
      this.getMenuItemList();
      this.getSubMenuList();
      // this.getCategoryList();
      // this.categoryList = [];
    },

    subMenuId() {
      // alert("hello")
      this.getCategoryList();
    },

    categoryId() {
      this.getItemsList();
      // this.getCategoryList();
    },
  },

  methods: {
    viewProduct(product) {
      this.popupProduct = product;
      this.popUpOn = 1;
      // alert(this.popupProduct);
    },

    closePopup() {
      this.popUpOn = 0;
    },

    handleBody() {
      this.showBody = false;
      this.showMenuMain = true;
    },

    handleMenuMain() {
      this.showMenuMain = false;
      this.showBody = true;
    },

    getMenuItemList() {
      // console.log("getmenuitemList");
      this.loading = true;
      this.list = [];

      // this.catList = [];
      this.showCatList = false;

      const data = {
        loc_id: LocationId.getLocationId(),
        menu_id: this.realMenuId,
      };

      axios
        .post("https://deus.khaanpin.com/appapi/menu/items/", data)
        .then((res) => {
          // console.log(
          //   res.data.data,
          //   "hello this is res from productfeaturelist.vue"
          // );
          // this.showNoData = false;

          if (res.data.error == false) {
            // this.showError = false;
            // console.log("kiran")
            this.categoryListLoading = false;
            this.list = res.data.data;
            this.loading = false;
          }
        })
        .catch((error) => {
          // this.showError = true;
          this.loading = false;
          // this.showNoData = false;

          console.log(error);
        });
    },

    getCategoryId(id) {
      // alert(id);
      this.categoryId = id;
    },

    getItemsList() {
      this.loading = true;
      // this.list = [];
      this.catList = [];
      const data = {
        loc_id: LocationId.getLocationId(),
        // cat_id: 59,
        cat_id: this.categoryId,
      };

      axios
        .post("https://deus.khaanpin.com/appapi/items/", data)
        .then((res) => {
          // console.log(
          //   res.data.data,
          //   "hello this is res from productfeaturelist.vue"
          // );

          if (res.data.error == false) {
            // this.showError = false;
            this.showCatList = true;
            // this.showNoData = false;

            this.catList = res.data.data;
            // console.log(this.catList, "this.catList");
            this.loading = false;
          } else {
            this.loading = false;
            this.showCatList = true;

            this.list = [];
            this.catList == [];
            // if (this.catList.length == 0){
            //   // alert("no item found")
            //   // this.list = [];
            // this.catList = [];
            // this.list = [];

            // }

            // console.log(this.catList, "this.catList error");

            // this.showNoData = true;
            // this.catList = [];
          }
        })
        .catch((error) => {
          this.loading = false;
          // this.list = [];

          this.catList = [];
          // this.showNoData = true;

          console.log(error);
        });
    },

    getSubMenuList() {
      // alert("helo")
      const data = {
        loc_id: LocationId.getLocationId(),
        menu_id: this.realMenuId,
      };

      axios
        .post("https://deus.khaanpin.com/appapi/submenu/", data)
        .then((res) => {
          // console.log(
          //   res.data.data,
          //   "hello this is res from productfeaturelist.vue hellllllllloooo"
          // );

          this.subMenuList = res.data.data;
          // this.loading = false;
        });
    },

    getSubmenuId(id) {
      // alert(id.id)
      this.subMenuId = id.id;
      this.subMenuHeader = id.name;
      // alert(this.subMenuHeader)
      // this.offAll = false;
    },

    getCategoryList() {
      // alert("helo");
      // this.categoryList = [];
      this.showError = true;
      this.categoryListLoading = true;

      const data = {
        loc_id: LocationId.getLocationId(),
        sub_menu_id: this.subMenuId,
      };

      axios
        .post("https://deus.khaanpin.com/appapi/category/", data)
        .then((res) => {
          // console.log(
          //   res,
          //   "hello this is res from productfeaturelist.vue hellllllllloooo"
          // );
          this.categoryListLoading = false;

          if (res.data.error == false) {
            this.showError = false;
            this.showSubCategory = true;

            this.categoryList = res.data.data;
          }

          // else {
          //   this.showError = true;
          // }

          // this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.showError = true;
        });
    },
  },

  mounted() {
    // this.realMenuId = this.realMenuId;
    // this.getMenuItemList();
    // this.getSubMenuList();
    // this.getCategoryList();
    // this.getItemsList();
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,800;1,700&display=swap");

.productFeature__main {
  display: flex;
  // border: 1px solid black;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.productFeature__menuMain {
  display: flex;
  align-items: center;
  justify-content: center;
  // border: 1px solid black;
  background: #ed2027;
  padding: 5px 15px;
  border-radius: 22px;
  cursor: pointer;
}

.productFeature__menuAll {
  display: flex;
  align-items: center;
  justify-content: center;
  // border: 1px solid black;
  padding-top: 5px;
  padding-right: 10px;
}

.productFeature__menuAll > h3 {
  color: white;
  font-family: "Open Sans", sans-serif;
  letter-spacing: 1.2px;
  font-weight: 520;
  font-size: 14px;
  text-transform: uppercase;
}

.productFeature__body {
  // border: 1px solid black;
  padding: 20px 10px;
  border-radius: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 65%;
  position: relative;
}

.productFeature__head {
  display: flex;
  align-items: center;
}

.productFeature__head > h3 {
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 700;
  color: rgb(90, 90, 90);
  // margin-bottom: 10px;
}

.productFeature__head > img {
  height: 13px;
  position: absolute;
  right: 0;
  top: 0;
  margin: 15px 8px;
  cursor: pointer;
  // border: 1px solid black;
}

.productFeature__submenu {
  // border: 1px solid black;

  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.productFeature__submenuActive {
  font-size: 14px;

  font-weight: bolder;
  letter-spacing: 0.8px;
  font-family: "Open Sans", sans-serif;
  text-transform: uppercase;
  padding: 4px 15px;
  margin: 4px 0;
  border-right: 1px solid #e7e9f3;
  background: #ed2027;
  color: white;
  cursor: pointer;
}

.productFeature__submenuInactive {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.8px;
  margin: 4px 0;

  font-family: "Open Sans", sans-serif;
  text-transform: uppercase;
  padding: 4px 15px;
  border-right: 1px solid #c0c0c0;
}

.productFeature__submenuInactive:hover {
  background: #ed2027;
  cursor: pointer;
  color: white;
}

.productFeature__catLoading{
  // border : 1px solid black;
    margin-left: 10px;

  // text-align: end;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 15px;
  // color: #ed2027;

}

.productFeature__showError {
  // margin-left: 10px;
  // // text-align: end;
  // font-family: "Open Sans", sans-serif;
  // font-weight: 500;
  // letter-spacing: 0.7px;
  // font-size: 14px;

      margin-left: 10px;

  // text-align: end;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  letter-spacing: 0.5px;
  font-size: 15px;
}

.productFeature__subCategory {
  // border: 1px solid black;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 10px 0;
  padding: 10px;
  background: #f2f2f2;
}

.main__list {
  width: 100%;
  min-height: 50vh;
  display: flex;
  justify-content: center;
}

.menu-list {
  margin: 50px 0;
  width: 65%;
}

.menu-list-content {
  .filter-part {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    // font-family: $main-font;
    margin: 30px 0 70px;
    .filter {
      cursor: pointer;
      i {
        padding-right: 8px;
      }
      font-size: 16px;
      /* color: #282828; */
      font-weight: 500;
      margin-right: 40px;
    }
    .sort {
      font-size: 16px;
      color: #8b8b99;
      display: inline-block;
      .ant-select {
        margin-left: 10px;
      }
    }
  }
}

.filter-content {
  padding: 15px 80px 60px;
  .cross {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    .img-wrap {
      width: 18px;
    }
  }
}

@media only screen and (max-width: 960px) {
  .productFeature__body {
    width: 88%;
  }

  .productFeature__submenuInactive,
  .productFeature__submenuActive {
    font-size: 13px;
  }
}
</style>
